export default {
  addPanel: 'Panel hinzufügen',
};
